const Builder = require('../BuilderBase');
const DetailPane = require('../DetailPane');
const Layout = require('../Layout');
module.exports = class SummaryDetailLayout extends Builder {
    constructor(title, properties) {
        super('layout_SummaryDetailLayout', title, properties);
    }

    layout(options) {
        let layout = new Layout('testLayout');
        // Important that this adds the block to the 'list' input name otherwise
        // it will be prevented by the block's setCheck (which is detailPanes only)
        // See layout.js for details.
        this.addChildBlock(layout, 'list', options);
        return layout;
    }

    detailPane(title, forAction, properties, options) {
        let detailPane = new DetailPane('testDetailPane', {
            namespace: properties.namespace,
            relation: properties.relation,
            forAction: forAction
        });
        this.addChildBlock(detailPane, undefined, options);

        return detailPane;
    }
};
